import i18n from '@yandex-int/i18n';

import { ru } from './ru';
import { en } from './en';

export const i18nPermanentLinkScreen = i18n({ ru, en });
